function connect(cb) {
  if (window.NativeAPI && window.NativeAPI.sendToNative) {
    cb();
  } else {
    document.addEventListener('WebViewJavascriptBridgeReady', () => {
      if (window.NativeAPI && window.NativeAPI.sendToNative) {
        cb();
      }
    });
  }
}

let napi = null;

connect(() => {
  window.NativeAPI.sendToJavaScript = sendToJavaScript;
  napi = window.NativeAPI;
});

// --------------------------------------

let message_id = 1;

// 等待客户端的返回回调集合
const callback_set = {};

// 自定义的回调方法
const custom_js_methods = {};
// 默认方法，custom_js_methods里没有定义的方法fallback到默认方法
// 比如back，如果没这个方法的或者返回preventDefaul:true的话，可以阻止浏览器回退
const DEFAULT_JS_METHODS = {
  back: () => ({ preventDefault: false })
};

// 注册方法，提供给客户端调用
// 没有取消注册的方法，但是可以传fn为null
const registerMethod = (name, fn) => {
  custom_js_methods[name] = fn;
};

const getMethodByName = name => {
  return custom_js_methods[name] || DEFAULT_JS_METHODS[name];
};

// --------------------------------------

// Client -> JS
function sendToJavaScript(message) {
  try {
    message = JSON.parse(message);
  } catch (e) {
    throw new Error('NativeAPI response syntax error: ' + message);
  }

  // console.log('native -> js:', message);

  if (message.method) {
    // 客户端调用JS方法
    let method = getMethodByName(message.method);

    if (method) {
      const result = method(message.params);
      napi.sendToNative(JSON.stringify({
        jsonrpc: '2.0',
        result,
        id: message.id
      }));
    }
  } else if (message.id) {
    // 客户端返回结果
    handleMessageResponse(message);
  } else {
    throw new Error('NativeAPI error message: ' + message);
  }
}

function handleMessageResponse(message) {
  const callback = callback_set[message.id];
  callback_set[message.id] = undefined;

  if (!callback) {
    throw new Error(`NativeAPI missing callback for: ${message}`);
  }

  callback(message.error || null, message.result);
}

// 调用客户端方法
const noop = () => {};
function invoke(method, params = null, callback = noop) {
  if (!napi) {
    callback({
      code: -32100,
      message: 'nativeapi not ready',
      data: {
        method,
        params
      }
    });
  } else {
    let msg = {
      jsonrpc: '2.0',
      method,
      params,
      id: message_id
    };
    message_id++;

    callback_set[msg.id] = (error, result) => {
      callback(error, result);
    };

    // console.log('js -> native:', msg);
    napi.sendToNative(JSON.stringify(msg));
  }
}

const HuoliBridge = {
  invoke,
  on: registerMethod,
  ready: connect,
};

export default HuoliBridge;



// WEBPACK FOOTER //
// ./src/utils/huoli-bridge.js